import React from 'react';
import { ArrowDown, Bot, Shield, Globe } from 'lucide-react';
import './PlatformExplanation.css';

const PlatformExplanation = () => {
  return (
    <section className="platform-section section" id="platform" data-testid="platform-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title" data-testid="platform-title">Governance Before Communication</h2>
          <p className="section-subtitle">
            VantaSignal evaluates AI-generated communication against policy, alignment, and risk controls before publication.
          </p>
        </div>
        
        <div className="flow-diagram" data-testid="flow-diagram">
          <div className="flow-step">
            <div className="flow-icon-wrapper flow-icon-ai">
              <Bot size={28} />
            </div>
            <span className="flow-label">AI Tools</span>
            <p className="flow-desc">Generate communication drafts</p>
          </div>
          
          <div className="flow-arrow">
            <ArrowDown size={24} />
          </div>
          
          <div className="flow-step flow-step-main">
            <div className="flow-icon-wrapper flow-icon-vanta">
              <Shield size={28} />
            </div>
            <span className="flow-label">VantaSignal</span>
            <span className="flow-badge">Governance Layer</span>
            <p className="flow-desc">Policy • Alignment • Risk Control</p>
          </div>
          
          <div className="flow-arrow">
            <ArrowDown size={24} />
          </div>
          
          <div className="flow-step">
            <div className="flow-icon-wrapper flow-icon-public">
              <Globe size={28} />
            </div>
            <span className="flow-label">Public Communication</span>
            <p className="flow-desc">Approved, compliant messaging</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PlatformExplanation;
